import { render, staticRenderFns } from "./cly-pic-upload.vue?vue&type=template&id=1d22e50a"
import script from "./cly-pic-upload.vue?vue&type=script&lang=js"
export * from "./cly-pic-upload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports